import { Badge, Link, IndexTable, Text } from '@shopify/polaris';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { listPermissions, listRoles } from '../../../services/rolesService';

const ListRoles = forwardRef((props, ref) => {
  const [rows, setRows] = useState([]);
  const [domains, setDomains] = useState([]);
  const showRoleEndpoint = (id) => `/users/roles/${id}/edit?r=${window.btoa('/users/roles/')}`;

  const callDB = () =>
    Promise.all([listPermissions(), listRoles()]).then(([p, r]) => {
      const act = p.data.permissions;
      setDomains(act);
      setRows(r.data.roles.map((r, k) => rowMarkup(r, k, act)));
    });

  useEffect(() => {
    callDB();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useImperativeHandle(ref, () => ({
    renew() {
      callDB();
    },
  }));

  const rowMarkup = ({ id, name, permissions }, index, domains) => (
    <IndexTable.Row id={id} key={id} position={index}>
      <IndexTable.Cell>
        <Link dataPrimaryLink url={showRoleEndpoint(id)}></Link>
        <Text variant="bodyMd" fontWeight="bold" as="span">
          {name}
        </Text>
      </IndexTable.Cell>

      {domains.map(({ domain }) => (
        <IndexTable.Cell key={`p_${domain}_${id}`}>
          {permissions
            .map((p) => p.split(':'))
            .filter((e) => e[0] === domain)
            .map((e, k) => (
              <div key={k}>
                <Badge size="small">{e[1]}</Badge>
              </div>
            ))}
        </IndexTable.Cell>
      ))}
    </IndexTable.Row>
  );

  const headingMarkup = [{ title: 'Nombre' }, ...domains.map(({ title }) => ({ title }))];

  return (
    <>
      {rows.length && (
        <>
          <IndexTable
            resourceName={{
              singular: 'rol',
              plural: 'roles',
            }}
            itemCount={rows.length}
            headings={headingMarkup}
            selectable={false}
          >
            {rows}
          </IndexTable>
        </>
      )}
    </>
  );
});

export default ListRoles;
